/*
  Component to get the width of a rendered text string.
  Can be useful to set the width of an input field based on the input value.

  Example:

  <TextRenderWidth text="01.01.2018">
    {width => (
      <DatePicker
        value="01.01.2018"
        style={{width}}
      />
    )}
  </TextRenderWidth>
*/

import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'

class TextRenderWidth extends React.Component {
  constructor(props) {
    super(props)
    this.hiddenElementRef = React.createRef()

    this.state = {
      width: null,
    }
  }

  componentDidMount() {
    this.setState({
      width: this.getWidth()
    })
  }

  componentDidUpdate(props, state) {
    const width = this.getWidth()
    if (state.width !== width) {
      this.setState({width})
    }
  }

  getWidth = () => get(this.hiddenElementRef.current, 'offsetWidth')

  render() {
    const {text, children, buffer} = this.props
    let {width} = {...this.state}

    if (width && buffer) {
      width += buffer
    }

    return (
      <React.Fragment>
        <span
          ref={this.hiddenElementRef}
          style={{
            visibility: 'hidden',
            whiteSpace: 'nowrap',
            position: 'absolute',
            zIndex: -1,
          }}
        >
          {text}
        </span>

        {children(width)}
      </React.Fragment>
    )
  }
}

TextRenderWidth.propTypes = {
  text: PropTypes.string.isRequired,
  buffer: PropTypes.number,
}

TextRenderWidth.defaultProps = {
  buffer: 4,
}

export default TextRenderWidth
